import ProfileCollectionsBootstrap from 'modules/performance_v2/lib/ProfileCollectionsBootstrap'
import EmployeePerformancePage from 'modules/performance_v2/pages/EmployeePerformancePage'

const ProfileRootPage = () => {
  return (
    <ProfileCollectionsBootstrap>
      <EmployeePerformancePage rootPage="profile" />
    </ProfileCollectionsBootstrap>
  )
}

export default ProfileRootPage
